<template>
    <div class="row">
      <div class="col-10 col-md-6 offset-1 offset-md-3 white">
        <div class="row pa-4 grey lighten-4 no-gutters text-left body green--text text--darken-4">
          <div class="col-4">Name</div>
          <div class="col-5">Value</div>
          <div class="col-3"></div>
        </div>
        <template v-for="(item) in items">
          <ARecordEditor :model="model" :item="item" :key="item.id" @changed="loadItem(item)"></ARecordEditor>
        </template>
      </div>
    </div>
</template>

<script>
import axios from "../api/axios";
import ARecordEditor from "./ARecordEditor";

export default {
  name: "ARecordListEditor",
  components: {
    ARecordEditor
  },
  data() {
    return {
      model: "settings",
      items: []
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      try {
        const res = await axios.get(
          this.model + "?orderByColumn=id&orderByDir=asc"
        );
        if (res.data.ok) {
          this.items = res.data.d.items;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadItem(item) {
      try {
        const res = await axios.get(this.model + "/" + item.id);
        if (res.data.ok) {
          item.key = res.data.d.key;
          item.value = res.data.d.value;
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>